import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './WarningBox.module.scss';
import Icon, { IconName } from '../Icon/Icon';

export enum WarningBoxColorType {
  Neutral = 'neutral',
  Successful = 'succesful',
  Warning = 'warning',
  Error = 'error',
  Neutral2 = 'neutral2',
  Neutral3 = 'neutral3',
  Neutral4 = 'neutral4',
  Neutral5 = 'neutral5',
}

export interface WarningBoxProps {
  title: string;
  copy: string | ReactNode;
  icon?: IconName;
  className?: string;
  colorType: WarningBoxColorType;
  isReturn?: boolean;
}

const WarningBox: React.FC<WarningBoxProps> = ({ title, copy, colorType, className, icon, isReturn }) => {
  return (
    <div className={classNames(styles.root, styles[colorType], className, `${isReturn && '!p-[24px]'}`)}>
      {isReturn ? (
        <div className="flex gap-[16px] items-center justify-start w-full">
          {icon && (
            <div
              className={classNames(
                styles.icon,
                colorType === 'warning'
                  ? 'status-warning-surface status-warning-full rounded-full p-4'
                  : 'status-success-surface status-success-full rounded-full p-4',
              )}>
              <Icon name={icon} width={11} height={11} />
            </div>
          )}
          <div className="flex flex-col">
            <h3 className="typo-text-16--bold">{title}</h3>
            <p className="typo-text-14">{copy}</p>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.content}>
            <h3 className="typo-text-16--bold">{title}</h3>
            <p className="typo-text-14">{copy}</p>
          </div>
          {icon && (
            <div className={styles.icon}>
              <Icon name={icon} width={16} height={16} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WarningBox;
